
import { Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PhotoCard } from "../../components/PhotoCard";
import { Challenge as ChallengeType } from "../../lib/types";

type Props = {
  challenge: ChallengeType;
  hasSubmitted: boolean;
  onOpenCamera: () => void;
};

export function PhotoSubmissionSection({ challenge, hasSubmitted, onOpenCamera }: Props) {
  return (
    <section className="space-y-5 mb-6">
      <h2 className="text-2xl font-semibold text-bauhaus-darkgreen font-['Bebas_Neue'] tracking-wide">
        Today's Challenge: <span className="font-normal">{challenge.selectedPrompt?.text}</span>
      </h2>
      {hasSubmitted ? (
        <div className="bg-bauhaus-darkgreen border-2 border-bauhaus-green rounded-lg p-7 text-center flex flex-col items-center">
          <Camera className="h-12 w-12 mb-3 text-bauhaus-offwhite" />
          <h3 className="text-lg font-semibold text-bauhaus-offwhite">Submission Complete!</h3>
          <p className="text-bauhaus-offwhite/80">Your photo has been submitted. Check back later for results!</p>
        </div>
      ) : (
        <div className="bg-bauhaus-green border-2 border-bauhaus-darkgreen rounded-lg p-7 text-center flex flex-col items-center">
          <Camera className="h-12 w-12 mb-3 text-bauhaus-offwhite" />
          <h3 className="text-lg font-semibold text-bauhaus-offwhite">Ready to Snap?</h3>
          <p className="text-bauhaus-offwhite/80 mb-4">Take a photo that matches today's prompt.</p>
          <Button
            onClick={onOpenCamera}
            className="bg-bauhaus-offwhite text-bauhaus-green border-2 border-bauhaus-darkgreen hover:bg-bauhaus-offwhite/90 transition"
          >
            <Camera className="h-4 w-4 mr-2" />
            Open Camera
          </Button>
        </div>
      )}

      {challenge.submissions.length > 0 && (
        <div className="mt-5">
          <h3 className="text-lg font-medium text-bauhaus-darkgreen mb-2">
            Submissions ({challenge.submissions.length})
          </h3>
          <div className="grid grid-cols-2 gap-3">
            {challenge.submissions.map(submission => (
              <PhotoCard
                key={submission.id}
                submission={submission}
                isVoted={false}
                onVote={() => {}}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
